var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"text":"","color":"white"}},[_c('v-toolbar-title',{directives:[{name:"ripple",rawName:"v-ripple",value:({ class: 'white--text' }),expression:"{ class: 'white--text' }"}]},[_c('router-link',{attrs:{"to":{ name: 'rodo' }}},[_c('v-layout',[_c('Logo')],1)],1)],1),_c('v-spacer'),_c('TaskBell'),_c('UserSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }